import React, {Component, Fragment} from 'react';
import {connect, Field, FieldArray, ErrorMessage} from 'formik';
import {FormattedMessage, injectIntl} from 'react-intl';
import classNames from 'classnames';
import get from 'lodash/get';
import messages from '../../../../res/translations/messages';
import ExpressionType from './ExpressionType';
import MinusButton from './MinusButton';
import FilterButton from './FilterButton';
import Error from '../../Error';
import TooltipContainer from '../../TooltipContainer';
import TooltipIcon from '../../TooltipIcon';
import {stripHtml} from '../../../utils/text';

// TODO remove disable lint
/* eslint-disable react/jsx-no-bind */
class ScriptRows extends Component {
    constructor(props) {
        super(props);
        this.addFilter = this.addFilter.bind(this);
        this.removeFilter = this.removeFilter.bind(this);
    }

    componentDidMount() {
        this.props.formik.registerField(this.props.id, this);
    }

    componentWillUnmount() {
        this.props.formik.unregisterField(this.props.id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.id !== prevProps.id) {
            this.props.formik.unregisterField(prevProps.id);
            this.props.formik.registerField(this.props.id, this);
        }
    }

    addFilter() {
        const {formik, id} = this.props;
        let scripts = get(formik.values, id);
        if (!scripts) {
            scripts = [];
        }
        formik.setFieldValue(id, scripts.concat({expression: [], id: ''}));
    }

    removeFilter(index) {
        const {formik, id} = this.props;
        const scripts = get(formik.values, id);
        const newScripts = scripts.slice();
        newScripts.splice(index, 1);
        formik.setFieldValue(id, newScripts);
    }

    render() {
        const {intl, formik, id, currPage, postScript, items} = this.props;
        const pages = formik.values.editor.pages;
        const previousPages = postScript ? pages.slice(0, currPage + 1) : pages.slice(0, currPage);
        let currRows = formik.values.editor.pages[currPage].items[0].rows || [];
        currRows = currRows.map((row) => {
            if (row.label) {
                return Object.assign(row, {value: row.label.replace(/<[^>]+>/g, '')});
            }

            if (row.minLabel && row.maxLabel) {
                return Object.assign(row, {value: `${row.minLabel} - ${row.maxLabel}`});
            }

            if (row.value) {
                return row;
            }
        }).filter((row) => row != null);
        return (
            <Fragment>
                {get(formik.values, id) && get(formik.values, id).map((script, index) => (
                    <div className="script" key={index}>
                        <div className="row pr-2 align-items-center">
                            <div className="col-9">
                                <FieldArray name={`${id}.${index}.expression`}
                                    render={(arrayHelpers) => (
                                        <div key={index}>
                                            <Field name={`${id}.${index}.expression`} previousPages={previousPages} items={items} component={ExpressionType}
                                                push={arrayHelpers.push}
                                                remove={arrayHelpers.remove}
                                            />
                                        </div>
                                    )}
                                />

                            </div>
                            <div className="col-3">
                                <label className="col-form-label" htmlFor={`${id}.${index}.id`}>
                                    <FormattedMessage {...messages.jumps.label.row} />
                                    {' '}
                                    <TooltipIcon message={messages.jumps.tooltip.row} />
                                </label>
                                <div className="d-flex">
                                    <Field id={`${id}.${index}.id`} name={`${id}.${index}.id`}
                                        className={classNames('form-control custom-select',
                                            {error: get(formik.errors, `${id}.${index}.id`) && get(formik.touched, `${id}.${index}.id`)})}
                                        component="select">
                                        <option value="" > {intl.formatMessage(messages.filters.select)} </option>
                                        {currRows.map(
                                            (row) => <option key={row.id} value={row.id}>
                                                {`${row.id} - ${stripHtml(row.value)}`}
                                            </option>)
                                        }
                                    </Field>
                                    <TooltipContainer tooltip={messages.jumps.tooltip.remove}>
                                        <MinusButton className="ml-2" remove={this.removeFilter} index={index} />
                                    </TooltipContainer>
                                </div>
                                <ErrorMessage name={`${id}.${index}.id`}>
                                    {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                </ErrorMessage>
                            </div>
                        </div>
                    </div>
                ))}
                <FilterButton onClick={this.addFilter}><FormattedMessage {...messages.jumps.button.new} /></FilterButton>
            </Fragment>
        );
    }
}

export default connect(injectIntl(ScriptRows));
